import React from 'react'
import ProductCard from './ProductCard'

export default function ProductSection({ label, products }) {
  return (
    <section className="section">
      <p className="section-label">{label}</p>
      <div className="cards-grid">
        {products.map((product) => (
          <ProductCard key={product.title} product={product} />
        ))}
      </div>
    </section>
  )
}
